export default __webpack_public_path__ + "static/media/home-page.9457a8c8.png";